import React, { memo, useContext } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';

const classicUrl = (location, medium) => {
  const path =
    location.pathname === '/search' ? '/search.php' : location.pathname;

  const searchQuery =
    location.search && location.pathname === '/search'
      ? `?q=${location.search.split('=').pop()}`
      : location.search;

  return `/_internal/switch-platform/classic?path=${encodeURIComponent(
    `${path + searchQuery}${
      location.search ? '&' : '?'
    }utm_source=rfe-exit&utm_medium=${medium}`
  )}`;
};

const ClassicSwitchLink = styled.a`
  :hover span {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

const ClassicSwitch = ({ utmMedium, children, location }) => {
  const context = useContext(AppContext);

  if (!context.market.showClassicSwitch || context.renderMode === 'beta') {
    return null;
  }

  return (
    <ClassicSwitchLink href={classicUrl(location, utmMedium)} rel="nofollow">
      {children}
    </ClassicSwitchLink>
  );
};

ClassicSwitch.propTypes = {
  children: PropTypes.node,
  utmMedium: PropTypes.string,
  location: PropTypes.object.isRequired,
};

ClassicSwitch.defaultProps = {
  children: undefined,
  utmMedium: undefined,
};

export default memo(withRouter(ClassicSwitch));
